var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPzu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.66669C14.1421 1.66669 17.5 4.98812 17.5 9.08532C17.5 11.7966 15.2314 14.6632 10.7902 17.786L10 18.3334L9.52316 18.0043C4.87535 14.7966 2.5 11.8596 2.5 9.08532C2.5 4.98812 5.85786 1.66669 10 1.66669ZM10 3.31527C6.77834 3.31527 4.16667 5.89861 4.16667 9.08532C4.16667 11.0874 6.0806 13.5304 10 16.3182C13.9194 13.5304 15.8333 11.0874 15.8333 9.08532C15.8333 5.89861 13.2217 3.31527 10 3.31527ZM10 5.00002C11.8409 5.00002 13.3333 6.4924 13.3333 8.33335C13.3333 10.1743 11.8409 11.6667 10 11.6667C8.15905 11.6667 6.66667 10.1743 6.66667 8.33335C6.66667 6.4924 8.15905 5.00002 10 5.00002ZM10 6.66669C9.07952 6.66669 8.33333 7.41288 8.33333 8.33335C8.33333 9.25383 9.07952 10 10 10C10.9205 10 11.6667 9.25383 11.6667 8.33335C11.6667 7.41288 10.9205 6.66669 10 6.66669Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPzu);
export default __webpack_public_path__ + "static/media/pzu.9705576e.svg";
export { ForwardRef as ReactComponent };